import { http } from '../../core/services/http';

const generateDeviceRegistrationCode = () =>
  http.get('vendors/generateDeviceRegistrationCode').then(response => response.data);

export default generateDeviceRegistrationCode;
